import { createAsyncThunk } from '@reduxjs/toolkit';
import { connectApi } from '@app/api';
import _ from 'lodash';
import { selectActiveCompanyId } from '@features/workspace/store/selectors';
import moment from 'moment/moment';
import {
  fetchEmployee,
  fetchUser,
} from '@features/workspace/store/actions/fetch';
import { IAppDispatch, IRootState } from '@app/store';

export const createUserNew = createAsyncThunk<
  any,
  any,
  { state: IRootState; dispatch: IAppDispatch }
>('user/create', async ({ data }, { dispatch, getState }) => {
  const userData = _.omit(data, [
    'person',
    'address',
    'assignment',
    'position',
  ]);
  const addressData = data.address;
  const personData = _.omit(data.person, ['identityDocuments']);
  const identityDocumentsData = data.person.identityDocuments;
  const firstIdentityDocumentData = identityDocumentsData[0];
  const position = data.position;

  const companyId = selectActiveCompanyId(getState());

  if (firstIdentityDocumentData && !firstIdentityDocumentData.issuingDate) {
    firstIdentityDocumentData.issuingDate = moment()
      .add(-1, 'years')
      .format('YYYY-MM-DD HH:mm:ss');
  }
  if (firstIdentityDocumentData && !firstIdentityDocumentData.expirationDate) {
    firstIdentityDocumentData.expirationDate = moment()
      .add(10, 'years')
      .format('YYYY-MM-DD HH:mm:ss');
  }

  const transformedData = {
    user: {
      ...userData,
      password: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      username: userData.email,
    },
    person: personData,
    address: addressData,
    identityDocument: firstIdentityDocumentData,
    companyId,
    position,
    phoneNumber: userData.phoneNumber,
    email: userData.email,
    userExperienceTerm: userData.userExperienceTerm,
  };

  const res = await connectApi.user.createNew(transformedData);

  // Fetch updated user and employee data

  dispatch(fetchUser(res.data.payload));
  dispatch(fetchEmployee({ companyId, userId: res.data.payload }));
});

export const createUserAddress = createAsyncThunk<any, any>(
  'user/create-address',
  async ({ userId, data }) => {
    return (await connectApi.user.createAddress(userId, data))?.data?.payload;
  }
);

export const createCompanyAddress = createAsyncThunk<any, any>(
  'company/create-address',
  async ({ companyId, data }) => {
    return (await connectApi.company.createAddress(companyId, data))?.data
      ?.payload;
  }
);

export const assignEmployee = createAsyncThunk<any, any>(
  'employee/assign',
  async ({ companyId, contactId, position }, { dispatch }) => {
    return (await connectApi.employee.assign(companyId, contactId, position))
      ?.data?.payload;
  }
);

export const createTraderootMember = createAsyncThunk<any, string>(
  'traderoot/create',
  async (companyId) => {
    await connectApi.bankAccount.createTraderootMember(companyId);

    return {};
  }
);

export const createBankAccount = createAsyncThunk<
  any,
  {
    companyId: string;
    accountAlias: string;
    accountProductType: number;
  }
>('account/create', async (data) => {
  return (await connectApi.bankAccount.createBankAccount(data))?.data?.payload;
});

export const createEmailChangeRequest = createAsyncThunk<
  any,
  { userId: string; email: string }
>('user/createEmailChangeRequest', async (data) => {
  return (await connectApi.user.createEmailChangeRequest(data))?.data?.payload;
});
